//- Реклама и счётчики
import insertInreadAdvs from '../../services/inread/insert-inread-advs.js';
import Counter from '../../services/counter';
import Socials from '../socials/index';
import Referrer from '../../services/referrer';
import VoxAd from '../../services/vox-ad/index.js';
import updateYmCounter from '../../services/ym/index.js';

//- Интерактивные элементы
import Gallery from '../gallery';
import Podcast from '../podcast';

//- Оптимизация загрузки
import Lazyloading from '../../services/lazy-loading/lazyLoading';
import LazyLoaderGoogs from '../../services/lazy-loading/lazyLoadingGoods';
import Comments from '../comments/comments.js';

/**
 * Класс уплравления публикациями
 *
 * @class Publication
 */
class Publication {
	/**
	 * Создает экземпляр Publication.
	 * @memberof Publication
	 */
	constructor() {
		this.insertContainer = document.querySelector('#feed'); // Контейнер "бесконечной" ленты

		this.gridContainerList = null; // Список публикация (?)
		this.typePublication = null; // Тип публикации
		this.lastPublication = null; // Последняя публикация
		this.nextPublicationApi = null; // API для получения следующей публикации
		this.footerPublication = null; // Узел подвала статьи
		this.options = {}; // Настройки
		this.nextPublication = null; // Следующая публикация
		this.start = false; // Если первая публикация
		this.isAuthorized = null;

		this.comments = document.querySelector('.comments');
		this.metaTitle = document.querySelector('meta[name="title"]'); // Мета заголовок
		this.metaDescription = document.querySelector('meta[name="description"]'); // Мета описание
		this.metaCanonical = document.querySelector('link[rel="canonical"]'); // Каноническая ссылка
		this.metaAmp = document.querySelector('link[rel="amphtml"]'); // Ссылка на AMP страницу

		this.setProperties();

		// Инициализация ссылок на социальные сети
		Socials.initRedirectLinks('.socials-posting');

		// Инициализация ссылок поделиться
		Socials.initShareLinks('.socials-sharing');

		this.refreshPublicationInteractivity();

		console.info('type', this.typePublication);

		if (this.typePublication === 'article') {
			this.publicationsUrlObserver = new IntersectionObserver(this.handleIntersectionUrl.bind(this), {
				root: null,
				rootMargin: '0px',
				threshold: 0.1,
			});

			new Referrer(document.referrer, location.href).setCounter();

			this.initInfinityFeed();
		}
	}

	//- Методы Set и Get

	/**
	 * Сеттер параметров публикации
	 *
	 * @memberof Publication
	 */
	setProperties() {
		this.gridContainerList = this.insertContainer.querySelectorAll('.grid-container');

		if (this.gridContainerList) {
			this.lastPublication = [...this.gridContainerList].pop().firstChild;
			this.typePublication = this.lastPublication.dataset.type;
			this.nextPublicationApi = this.lastPublication.dataset.nextPublication;
			this.footerPublication = this.lastPublication.querySelector('.content-footer');
			this.options = {
				root: null,
				rootMargin: '0px',
				threshold: 0.1,
			};
		}
	}

	/**
	 * Геттер следующей статьи
	 *
	 * @return {*} JSON
	 * @memberof Publication
	 */
	async getPublication() {
		if (this.nextPublicationApi) {
			try {
				const response = await fetch(this.nextPublicationApi);

				if (!response.ok) {
					throw new Error('[js] Error sending request');
				}

				return { ...(await response.json()) };
			} catch (exception) {
				console.error(exception);
			}
		}
	}

	//- Служебные методы

	/**
	 * Запускает/перезапускает скрипты отвечающие за интеракцивные элемента в публикации. (Галереи, реклама...)
	 *
	 * @memberof Publication
	 */
	refreshPublicationInteractivity() {
		// Инициализация инридов
		if ('MKInreadsInArticle' in window) {
			insertInreadAdvs(window.MKInreadsInArticle, [...this.gridContainerList].pop());
			console.info('[js] Inreads have been inserted');
		}

		// Инициализация рекламы на картинках
		new VoxAd(this.lastPublication?.dataset?.id).init();

		// Инициализация галерей
		const galleres = this.lastPublication.querySelectorAll('.gallery');

		if (galleres) {
			galleres.forEach((gallery) => {
				console.log(gallery);
				new Gallery(gallery);
			});
		}

		this.comments = this.lastPublication.querySelector('.comments');
		if (this.comments) {
			this.isAuthorized = this.comments.dataset.authorized;

			console.log(this.comments, this.isAuthorized);
			new Comments(this.comments, this.isAuthorized);
		}

		// Инициализация подкастов
		if (this.typePublication === 'podcast') Podcast.init(this.lastPublication);

		// Инициализация счётчика
		new Counter(this.lastPublication).update();

		// Ленивая загрузка КАРТИНОК
		new Lazyloading('img[loading=lazy]').init();

		// Ленивая загрузка РЕКЛАМЫ
		new LazyLoaderGoogs('script[data-src]').init();
	}

	/**
	 * Обновляет *meta* поля документа на основе текущей публикации
	 *
	 * @param {*} currentPublication - текущая публикация
	 * @memberof Publication
	 */
	updateMetaData(currentPublication) {
		const metaTitle = currentPublication.querySelector('h1')?.innerText;
		this.metaTitle.setAttribute('content', metaTitle);
		document.title = metaTitle;

		const metaDescription = currentPublication.querySelector('.preview__text p')?.innerText;
		this.metaDescription.setAttribute('content', metaDescription);

		this.metaCanonical.setAttribute('href', location.href);

		this.metaAmp.setAttribute('href', location.origin + '/amp' + currentPublication.dataset.url);
	}

	//- Обработчики событий

	/**
	 * Обработчик вхождения узла *article > footer*.
	 *
	 * Как только узел *article > footer* поппадает в область видимости Intersection Observer,
	 * загружается следующая статья полученая по API, а также инициалзируются рекламные скрипты
	 * и скрипты учавствующие работе интерактивных эелементов страницы.
	 *
	 * @param {*} entries - элемент вхождения
	 * @param {*} observer - обозреватель
	 * @memberof Publication
	 */
	handleIntersectionFeed(entries, observer) {
		entries.forEach(async (entry) => {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target);
				this.nextPublication = await this.getPublication();
				if (this.nextPublication) {
					const range = document.createRange();
					const fragment = range.createContextualFragment(this.nextPublication?.html);

					this.insertContainer.appendChild(fragment);

					this.setProperties();
					this.refreshPublicationInteractivity();

					this.publicationsUrlObserver.observe(this.lastPublication);

					if (this.nextPublication?.nextArticleApi) {
						this.nextPublicationApi = this.nextPublication?.nextArticleApi;
						observer.observe(this.footerPublication);
					}
				}
			}
		});
	}

	/**
	 * Обработчик вхождения узла *article*.
	 *
	 * Как только узел *article* попадает в область видимости Intersection Observer,
	 * происходит обновление URL страницы и *meta* информаци страницы,
	 * а также обновляются счётчики метрик.
	 *
	 * @param {*} entries - элемент вхождения
	 * @memberof Publication
	 */
	handleIntersectionUrl(entries) {
		entries.forEach(async (entry) => {
			// eslint-disable-next-line sonarjs/no-collapsible-if
			if (entry.isIntersecting) {
				if (history?.state?.id !== entry.target.dataset.id) {
					const referrer = location.href;
					const destUrl = location.origin + entry.target.dataset.url;
					new Referrer(referrer, destUrl).setCounter();
					history.pushState({ id: entry.target.dataset.id }, '', entry.target.dataset.url);
					updateYmCounter(referrer, destUrl);
					this.updateMetaData(entry.target);
					// Инициализация ссылок поделиться
					Socials.initShareLinks(entry.target.querySelectorAll('.socials-sharing'), {
						url: location.href,
						messangerText: 'https://www.avtovzglyad.ru/',
						title: document.title,
					});
				}
			}
		});
	}

	//- Инициализация

	/**
	 * Инициализация "бесконечной" ленты (максимум записей в ленте 5)
	 *
	 * @memberof Publication
	 */
	initInfinityFeed() {
		this.observer = new IntersectionObserver(this.handleIntersectionFeed.bind(this), this.options);
		this.observer.observe(this.footerPublication);
		this.publicationsUrlObserver.observe(document.querySelector('.article'));

		console.info('[js] Infinity feed started');
	}
}

new Publication();
